import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {environment as env} from 'environments/environment';
import {SettingsProvider} from 'app/core/services/settings.service';
import {HttpService} from 'app/core/services/http.service';

@Injectable()
export class FilesService {

  constructor(
      private http: HttpService,
      public settingsService: SettingsProvider,
      ) { }

    // public sendFile(id: string): Observable<any> {
    //     const url = `${this.settingsService.configuration.url}${env.NotificationDataService.apiUrlSetAsRead}`;
    //     return this.http.post(url);
    // }

    public getFile(id: string): Observable<any> {
        const url = `${this.settingsService.configuration.url}${env.FilesService.apiUrlGetFile}/${id}`;

        return this.http.getType(url, 'image/jpeg');
    }
}
